export default __webpack_public_path__ + "static/media/AddIcon.b610f879.svg";